module.exports = __webpack_public_path__ + "static/media/arrow_right_desktop.e73ada31.svg";